module.exports = __webpack_public_path__ + "img/nadia_menotti.1bf31814.png";